// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'bell-solid';

export const Component = () => (
  <path d='m20.826 14.992 1.255 1.201c.28.267.419.579.419.934v.801c0 .4-.14.712-.419.98a1.4 1.4 0 0 1-1.023.4H3.942a1.4 1.4 0 0 1-1.023-.4 1.28 1.28 0 0 1-.419-.98v-.8c0-.356.14-.668.419-.935l1.255-1.2c.14-.179.233-.357.28-.535l.976-6.63c.232-1.646 1.024-3.026 2.372-4.138A7.213 7.213 0 0 1 12.5 2c1.72 0 3.301.578 4.65 1.69 1.396 1.157 2.186 2.536 2.42 4.183l.976 6.585c.046.178.14.356.279.534Zm-11.628 5.25h6.604a3.386 3.386 0 0 1-1.116 1.957c-.604.534-1.349.801-2.186.801-.836 0-1.58-.267-2.185-.8a3.386 3.386 0 0 1-1.116-1.958h-.001Z' />
);

export const viewBox = '0 0 25 25';
